/**
 * v-selectLoadMore
 * el-select实现 滚动条下拉触底加载更多
 */
import type { Directive, DirectiveBinding } from "vue";
import { debounce } from "lodash-es";

const selectLoadMore: Directive = {
    beforeMount(el: HTMLElement & { _handle: EventListenerOrEventListenerObject | null }, binding: DirectiveBinding) {
        // popperClassName自定义类名：一个页面可能存在多个下拉框，必须指定唯一的类名
        const popperClassName = el.getAttribute("popper-class-name")!;
        const selectDom = document.querySelector(`.${popperClassName} .el-select-dropdown__wrap`)!;
        // 监听防抖处理
        const handle = debounce(() => {
            let scrollDistance = selectDom.scrollHeight - selectDom.scrollTop;
            // 离底部距离10px时触发触底操作
            if (selectDom.clientHeight + 10 > scrollDistance) {
                binding.value(); // 触底操作
            }
        }, 200);
        // 绑定监听滚动事件
        selectDom?.addEventListener("scroll", handle);
        // 方法挂载到元素身上便于解绑时使用
        el._handle = handle;
    },
    // 实例销毁
    beforeUnmount(el: { _handle: EventListenerOrEventListenerObject | null }) {
        let scrollWrap: any = document.querySelector(".el-scrollbar__wrap");
        scrollWrap?.removeEventListener("scroll", el._handle);
        el._handle = null;
    }
};

export default selectLoadMore;
